// Module
var code = "<div class=\"subscriptions-typeahead-result clearfix\" ng-click=\"::context.onAdd(data)\"> {{ ::data.name }} </div> ";
// Exports
module.exports = code;